/*
  Was der Detaildialog der Mitarbeitenden-Ansicht zu einem Eintrag zeigt.
  Rein und ohne React, damit es sich ohne Oberfläche testen lässt.
*/

import { format, parseISO } from "date-fns";
import { de } from "date-fns/locale";

function formatDateKey(dateKey) {
  const key = String(dateKey || "").slice(0, 10);
  if (!key) return "";
  const date = parseISO(key);
  return Number.isNaN(date.getTime()) ? key : format(date, "EEEEEE, dd.MM.yyyy", { locale: de });
}

function formatDateRange(startKey, endKey) {
  const start = formatDateKey(startKey);
  const end = formatDateKey(endKey);
  if (!end || end === start) return start;
  return `${start} – ${end}`;
}

function compactRows(rows) {
  return rows.filter((row) => row.always || String(row.value || "").trim());
}

const EMPTY_COMMENT = "–";

/*
  Kopf ist die Abteilung, darunter Mitarbeitende, Datum, Zeit, Schicht und
  Kommentar (die "Notiz für Mitarbeitende" aus dem Schicht-Editor). Der
  Kommentar steht immer da, auch leer - sonst sucht man ihn.

  Mit Web page.shiftplan/employee_entry_comments ist er beim EIGENEN Eintrag
  bearbeitbar (editableComment) und steht dann als Eingabefeld statt als Zeile.
*/
function shiftDetails(shift, { currentEmployeeId = "", canEditOwnComments = false } = {}) {
  const isAbsence = shift.entryType === "absence";
  const editable =
    canEditOwnComments && Boolean(currentEmployeeId) && String(shift.employeeId) === String(currentEmployeeId);
  const endKey = String(shift.end || "").slice(0, 10);
  return {
    title: shift.department || shift.title || (isAbsence ? "Absenz" : "Schicht"),
    subtitle: "",
    rows: compactRows([
      { label: "Mitarbeitende", value: shift.employeeName },
      {
        label: "Datum",
        value: isAbsence ? formatDateRange(shift.dateKey, endKey) : formatDateKey(shift.dateKey),
      },
      { label: "Zeit", value: shift.timeLabel },
      // Bei Absenzen steht die Absenzart schon im Kopf.
      { label: "Schicht", value: isAbsence ? "" : shift.title },
      ...(editable ? [] : [{ label: "Kommentar", value: shift.note || EMPTY_COMMENT, always: true }]),
    ]).map(({ label, value }) => ({ label, value })),
    editableComment: editable ? { entryId: shift.id, value: shift.note || "" } : null,
  };
}

function holidayDetails(holiday, employeesById) {
  return {
    title: holiday.holidayTypeName || "Ferien",
    subtitle: "",
    rows: compactRows([
      { label: "Mitarbeitende", value: employeesById?.[holiday.userId]?.name },
      { label: "Datum", value: formatDateRange(holiday.startDate, holiday.endDate) },
    ]).map(({ label, value }) => ({ label, value })),
  };
}

export function buildEntryDetails(detail, employeesById = {}, options = {}) {
  if (!detail?.entry) return null;
  return detail.type === "holiday"
    ? holidayDetails(detail.entry, employeesById)
    : shiftDetails(detail.entry, options);
}
